export default build =>
  build.mutation({
    query(payload) {
      return { url: `/exam/getAgentSchoolWiseReport`, method: 'POST', body: payload };
    },
  });
